// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * If provided the slot is dedicated to this task (version-agnostic)
 */
export type CreateSlotsRequestBoundTaskId = string | null;
